<template>
  <JStreamPlayer class="player" :video-id="videoContentId" ref="jStream" />
</template>

<script>
import JStreamPlayer from "./JStreamPlayer"

export default {
  name: "JStreamManager",
  components: {
    JStreamPlayer
  },
  props: {
    videoContentId: {
      type: String,
      required: true
    },
    playVideo: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    player: function() {
      return this.$refs.jStream
    }
  },
  watch: {
    playVideo: function(newValue) {
      if (newValue === true) {
        this.player.play()
      }
    }
  }
}
</script>
